import { PdfTemplate, PdfTemplateIds } from '@hcs/types';

import { ProductSheetDexpPdf } from './ProductSheetDexpPdf';

export const productSheetsTemplateConfig: Partial<
  Record<PdfTemplateIds, PdfTemplate>
> = {
  [PdfTemplateIds.ProductSheetDexp]: ProductSheetDexpPdf,
};
